import React from 'react';
import * as mobxReact from 'mobx-react';
import { useIntl } from 'react-intl';
import { OEToggle } from '../../../../../global/oe-toggle/oe-toggle';
import Text from '../../../../../global/text/text';
import { FormField } from '../../../../../global/form/form-field/form-field';
import { InfoPopover } from '../../../../../global/info-popover/info-popover';
import { DefaultDatePicker } from '../../../../../global/default-datepicker/default-datepicker';
import { TimeInput } from '../../../../../global/time-input/time-input';
import { DATE_TEXT } from '../../../../../../constants/common-labels.constants';
import { MeetingGoLiveDateVM } from './meeting-go-live-date.viewmodel';
import * as TEXTS from './meeting-go-live-date.texts';
import './meeting-go-live-date.scss';

interface IMeetingGoLiveDateProps {
    vm: MeetingGoLiveDateVM;
    eventTimezone: string;
    dateFormat: string;
}

const MeetingGoLiveDate = mobxReact.observer(({ vm, eventTimezone, dateFormat }: IMeetingGoLiveDateProps) => {
    const intl = useIntl();
    const switchText = TEXTS.ENABLE_GO_LIVE_TEXT.message + (vm.enabled ? ' enabled' : ' disabled');
    const validationError = vm.getValidationError();

    return (
        <div className='meeting-go-live-date'>
            <div className='meeting-go-live-date__toggle-section m-bottom-25px flex meeting-toggle'>
                <div className='meeting-go-live-date__toggle'>
                    <OEToggle
                        isSelected={vm.enabled}
                        onClick={vm.toggleEnabled}
                    />
                    <Text {...TEXTS.ENABLE_GO_LIVE_TEXT} message={switchText} />
                </div>
                <InfoPopover>
                    <div>
                        <Text {...TEXTS.GO_LIVE_INFO_MESSAGE_TEXT} />
                    </div>
                </InfoPopover>
            </div>

            {vm.enabled && (
                <div className='m-bottom-25px'>
                    <div className='meeting-form__label'>
                        <FormField
                            label={intl.formatMessage(DATE_TEXT)}
                            className='meeting-form__form-field meeting-form__form-column'
                        >
                            <DefaultDatePicker
                                className='oe-form-field__control'
                                id='goLiveDate'
                                dateformat={dateFormat}
                                showTimeSelect={false}
                                selected={vm.selectedDate}
                                timeZone={eventTimezone}
                                onChange={vm.setGoLiveDate}
                            />
                        </FormField>
                        <FormField
                            label={intl.formatMessage(TEXTS.GO_LIVE_TIME_TEXT)}
                            className='meeting-form__form-field'
                        >
                            <TimeInput
                                className='oe-form-field__control'
                                date={vm.selectedTime}
                                disabled={!vm.selectedDate}
                                onChange={vm.setGoLiveTime}
                                onError={vm.clearGoLiveTime}
                                timeZone={eventTimezone}
                            />
                        </FormField>
                    </div>

                    {validationError && (
                        <span className='oe-form-field__error'>
                            {validationError}
                        </span>
                    )}
                </div>
            )}
        </div>
    );
});

export { MeetingGoLiveDate };
